/* eslint-disable no-param-reassign */
import validations from './validations';

export default {
  validations,
};

/**
 * Formata um número no formato de moeda BRL
 * @deprecated Utilize a função formatMoney da src/utils/number.js
 * @param {String|Number} number
 * @returns {String}
 */
export function formatNumber(number) {
  const handleNumber = number || 0;

  return Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    style: 'currency',
  }).format(handleNumber);
}

/**
 * @param {string} brlNumber
 */
export function convertBrlToDecimal(brlNumber) {
  if (!brlNumber) return 0;

  const handledString = brlNumber
    .replace('R$', '')
    .replaceAll('.', '')
    .replaceAll(',', '.');

  return parseFloat(parseFloat(handledString).toFixed(2));
}

/**
 * Formata uma data para o formato Y-m-d
 * @param {Number | Date} date
 * @returns
 */
export function formatDateToYmd(date) {
  if (!date) return '';

  const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
  const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(
    date
  );
  const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);

  return `${year}-${month}-${day}`;
}

/**
 * @param {string} url
 * @param {string} name
 */
export function downloadFile(url, name) {
  const link = document.createElement('a');
  link.download = name;
  link.href = url;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  link.remove();
}

/**
 * @param {string} base64 String Base64 a ser baixada
 * @param {string} fileName Nome do arquivo
 * @param {string} extension Extensão do arquivo (.pdf, .txt, .png), se omitido será utilizado o próprio
 * tipo contido na string base64
 * @param {Object} settings Configurações para realizar o download do arquivo
 * @param {String} settings.mimeType O Mime Type do arquivo (application/pdf, image/png etc.)
 * @param {Boolean} settings.addDataUriOnBase64 Indica se deve ser adicionado a string `data:mimeType,base64` ao começo
 * da string de base64
 */
export function downloadFileFromBase64({
  base64 = '',
  fileName = '',
  extension = null,
  mimeType = '',
  addDataUriOnBase64 = false,
}) {
  if (!base64) return;

  // exemplo: data:audio/ogg;base64,
  if (!extension) extension = base64.split('/')[1].split(';')[0];
  if (extension === 'plain') extension = 'txt';

  extension = extension[0] === '.' ? extension : `.${extension}`;

  if (addDataUriOnBase64 && mimeType)
    base64 = `data:${mimeType};base64,${base64}`;

  const link = document.createElement('a');
  link.href = base64;
  link.download = fileName.endsWith(extension)
    ? fileName
    : `${fileName}${extension}`;
  link.click();

  link.remove();
}

/**
 * @param {string} url
 * @returns {string}
 */
export function getYoutubeVideoUri(url) {
  if (!url) return '';

  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);

  if (match && match[2].length === 11) return match[2];

  return '';
}

/**
 * @param {Number} bytes
 * @param {Number} decimals
 * @returns
 */
export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}

/**
 * Converte um arquivo selecionado através de um input para sua representação em base64
 * @param {File} file
 * @returns {Promise<string>}
 */
export function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
